<template>
    <div class="title-bar">
        <slot></slot>
    </div>
</template>

<script>
    export default {
        name: 'TitleBar',
    };
</script>

<style scoped lang="scss">
    @import '~@/assets/styles/abstracts/_variables';
    @import '~@/assets/styles/abstracts/_placeholders';
    @import '~@/assets/styles/abstracts/_mixins';

    .title-bar {
        padding:          1rem 0;

        background-color: $color-brand;
        color:            $white;

        text-align: center;

        h1,span {
            @extend %font-OpenSans-regular;

            margin:         0;

            font-size:      2rem;
            line-height:    (30/24);
            text-transform: uppercase;
            text-align:     center;

            @media screen and (min-width: map_get($grid-breakpoints, 'sm')) {
                font-size: 2.4rem;
            }
        }

        &__visually-hidden {
            @include sr-only;
        }
    }
</style>
